import axios from 'axios'

const softDeleteSystemUser = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/softDeleteSystemUser/${id}`,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    console.log(response)
    return response.data
  } catch (error) {
    console.log(error)
    throw error
  }
}

export default softDeleteSystemUser
